<template>
  <div class="proEcode">
    <Input v-if="tableName == 'PS_C_PRO'" class="input-box" v-model="inputData" :placeholder="placeholder" :disabled="disabled" />
    <div v-if="tableName == 'PS_C_BRAND_MATCH'">
      <InputNumber
        v-model.trim="parseNum.start"
        :min="parseNum.min"
        :max="parseNum.max - 1"
        :step="parseNum.step"
        @on-blur="onBlurForInputNumber()"
      />
      <span>至</span>
      <InputNumber
        v-model.trim="parseNum.end"
        :min="parseNum.min"
        :max="parseNum.max"
        :step="parseNum.step"
        @on-blur="onBlurForInputNumber()"
      />
      <span>位</span>
    </div>
  </div>
</template>

<script>
import fieldDefined from '@/js/pages/commodityCenter/fieldDefined.js';
export default fieldDefined;
</script>
